module.exports = __webpack_public_path__ + "img/onboarding-domain-light.7ba82cfa.svg";